import { inlineScript } from "@decocms/blocks/sdk/useScript";
import type { AnalyticsEvent } from "@decocms/apps-commerce/types";

/**
 * String constant (not derived from a live function's `.toString()`) —
 * mirrors `~/sdk/analytics.ts#sendEvent`. Interpolating a function reference
 * here caused a hydration mismatch: `fn.toString()` output can differ
 * between the SSR and client Vite builds, so the inline script's HTML
 * literally differed server vs client. A plain string is byte-identical in
 * both builds. See @decocms/blocks/sdk/useScript.ts `inlineScript` docstring.
 */
const SEND_EVENT_JS = `(event) => {
  globalThis.dataLayer = globalThis.dataLayer || [];
  if (event.name === "deco") {
    globalThis.dataLayer.push({ event: event.name, deco: event.params });
    return;
  }
  globalThis.dataLayer.push({ ecommerce: null });
  globalThis.dataLayer.push({
    event: event.name,
    event_id: crypto.randomUUID(),
    ecommerce: event.params,
  });
}`;

/**
 * This function is usefull for sending events on click. Works with both Server and Islands components
 */
export const SendEventOnClick = <E extends AnalyticsEvent>({ event, id }: {
  event: E;
  id: string;
}) => (
  <script
    type="module"
    {...inlineScript(
      `addEventListener("load", () => {const element = document.getElementById("${id}"); element && element.addEventListener("click", () => (${SEND_EVENT_JS})(${
        JSON.stringify(event)
      }));})`,
    )}
  />
);

/**
 * This componente should be used when want to send event for rendered componentes.
 * This behavior is usefull for view_* events.
 */
export const SendEventOnLoad = <E extends AnalyticsEvent>(
  { event }: { event: E },
) => (
  <script
    type="module"
    {...inlineScript(
      `addEventListener("load", () => (${SEND_EVENT_JS})(${
        JSON.stringify(event)
      }))`,
    )}
  />
);
